import { html } from "lit";
import { msg } from "@lit/localize";

import type { FunctionDefinition } from "@progressive-development/pd-spa-helper";

// Read-Dispatcher (List/Detail/Search)
export const handleGetFunc: FunctionDefinition = {
  name: "handleAppGet",
  successCodes: [200],
  fadeWindow: false,
  successTxt: msg(html`Abfrage erfolgreich`, {
    id: "app.function.get.success",
  }) as any,
  pendingTxt: msg(html`Daten werden geladen…`, {
    id: "app.function.get.progress",
  }) as any,
};

// Write-Dispatcher (Add/Update/Delete)
export const handlePutFunc: FunctionDefinition = {
  name: "handleAppPut",
  successCodes: [200, 201],
  fadeWindow: false,
  successTxt: msg(html`Speichern erfolgreich`, {
    id: "app.function.put.success",
  }) as any,
  pendingTxt: msg(html`Daten werden gesendet…`, {
    id: "app.function.put.progress",
  }) as any,
};
